import {applicationKeyPrefix} from 'modules/app/constants';
import {renderApplicationPath} from 'paths';

export const setApplicationBasePath = application => {
    sessionStorage.setItem(applicationKeyPrefix + application + '.base-path', renderApplicationPath(application))
}

export const setApplicationResourceRoot = (application, resourceRoot) => {
    sessionStorage.setItem(applicationKeyPrefix + application + '.resource-root', resourceRoot)
}